const openFiltersContainer = () => {
    document.body.classList.add('trigger')
    document.querySelector('.filters__sp__container').classList.add('trigger')
}

const closeFiltersContainer = () => {
    document.body.classList.remove('trigger')
    document.querySelector('.filters__sp__container').classList.remove('trigger')
		
    let current = document.querySelector('.filters__sp__filter--trigger.trigger')

    if (current) 
        return current.classList.remove('trigger')
}

const openSubFilters = el => {

    let current = document.querySelector('.filters__sp__filter--trigger.trigger')

    if (current && current !== el)
        current.classList.remove('trigger')

    el.classList.toggle('trigger')
}

const closeSubFilters = () => {
    document.querySelector('.filters__sp__filter--trigger.trigger').classList.remove('trigger')
}

const checkFilter = el => {
    el.classList.toggle('trigger')

    let filter = document.querySelector('.filters__sp__filter--trigger.trigger').querySelector('span'),
        group  = el.parentElement.querySelectorAll('.filters__sp__checkbox.trigger')

    if (group.length > 0)
        return filter.setAttribute('data-count', '(' + group.length + ')')

    return filter.setAttribute('data-count', '')
}

const submitFilters = () => {
    document.querySelector('.filters__sp__container').classList.remove('trigger')
	document.querySelector('.filters__sp__loader').classList.add('trigger')
}

export {
    openFiltersContainer,
    closeFiltersContainer,
    openSubFilters,
    closeSubFilters,
    checkFilter,
    submitFilters
}